module.exports = __webpack_public_path__ + "assets/delete-comfirm.0143a553.svg";